var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 134.33 156.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ca247c;}.cls-2{fill:#d7006c;}.cls-3{fill:#040405;}.cls-4{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    className: "cls-1",
    d: "M42.83,35.81c0-18.3,12.36-33.13,27.62-33.13S98.07,17.51,98.07,35.81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    className: "cls-2",
    d: "M76.26,155.58H48.82c-60.09,0-52.66-79.74-40.29-113.24a44.39,44.39,0,0,1,6-6.23A52.55,52.55,0,0,1,48.82,23.77H76.26a53.17,53.17,0,0,1,30.88,9.62,49.6,49.6,0,0,1,4,3.2C123.94,48,125,65.71,125.38,80.69c.5,17.2,1.61,35.52-7,51.54-5.73,10.69-14.86,18.67-32.38,22.49a56.15,56.15,0,0,1-9.77.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    className: "cls-3",
    d: "M34,.05c1.62-1,11.3,14.48,31.83,22.71,10,4,17.22,4.14,17.54,5.87.4,2.24-10.85,5.92-21.88,2.46C42.85,25.25,32.05,1.28,34,.05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    className: "cls-3",
    d: "M109.65.05C108-1,98.35,14.53,77.82,22.76c-10,4-17.22,4.14-17.54,5.87-.4,2.24,10.85,5.92,21.88,2.46,18.62-5.84,29.42-29.81,27.49-31"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    className: "cls-3",
    d: "M71.4,156.22C73,153.37,66.17,120,70,67.81c1.87-25.43,5.26-41.74,4.13-43.75C72.7,21.48,64.53,44,61.76,71.31c-4.68,46.13,7.8,88.31,9.64,84.91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    className: "cls-2",
    d: "M78.83,30.36a9.17,9.17,0,1,1-9.17-9.17h0a9.17,9.17,0,0,1,9.17,9.17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    className: "cls-3",
    d: "M7.29,88.55C10,90.68,42,81.32,92.15,86.63c24.41,2.59,40.06,7.27,42,5.71,2.48-2-19.1-13.28-45.34-17.11C44.51,68.77,4,86,7.29,88.55"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    className: "cls-2",
    d: "M75,81.19c0,6-4,10.86-9,10.86s-9.06-4.86-9.06-10.86,4.06-10.86,9.06-10.86,9,4.86,9,10.86"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    className: "cls-4",
    d: "M58.94,91.87a66.56,66.56,0,0,0,3.18-16.24q.68,3.06,1.37,6.12L68.2,71.42a130.23,130.23,0,0,0,1.17,17.75Q71.1,84.1,72.84,79"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/Icon7.6b6ecfea18346ec75943c12044b01603.svg";
export { ForwardRef as ReactComponent };